export interface StatusData {
  serverOnline: boolean;
  /** 各市场最新交易日 —— 实测 A股与港股不同（港股国庆照常开市） */
  lastTradingDay: { cn?: string; hk?: string };
  source?: string;
  /** 是否命中本地缓存 */
  cached?: boolean;
  cacheTime?: string;
  hitRate?: number;
  /** L3：估值滞后告警 —— 中证 xls 是不可逆数据，漏抓永久丢失 */
  valuationAlert?: boolean;
  warnings?: string[];
}

/** UI-A 阶段无后端，全部为占位值；Phase 1 起接 /api/status */
const PLACEHOLDER: StatusData = {
  serverOnline: false,
  lastTradingDay: {},
};

export function StatusBar({ data }: { data?: StatusData | null }) {
  const d = data ?? PLACEHOLDER;
  const dot = d.serverOnline ? 'var(--down)' : 'var(--warn)';
  const alerts: string[] = [
    ...(d.valuationAlert ? ['估值数据滞后，部分日期已无法回补'] : []),
    ...(d.warnings ?? []),
  ];

  return (
    <footer
      className="flex min-h-[26px] shrink-0 items-center gap-3 overflow-x-auto whitespace-nowrap border-t px-3 pb-[env(safe-area-inset-bottom)] text-[11px]"
      style={{ background: 'var(--bg-surface)', color: 'var(--text-3)' }}
    >
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: dot }} />
        {d.serverOnline ? '服务已连接' : '服务未连接'}
      </span>

      {d.lastTradingDay.cn && (
        <span>
          沪深最新 <span className="num">{d.lastTradingDay.cn}</span>
        </span>
      )}
      {d.lastTradingDay.hk && (
        <span>
          港股最新 <span className="num">{d.lastTradingDay.hk}</span>
        </span>
      )}

      {d.source && <span>数据源 {d.source}</span>}
      {d.cached && d.cacheTime && <span>缓存 {d.cacheTime}</span>}
      {d.hitRate !== undefined && <span className="num">命中率 {d.hitRate}%</span>}

      {alerts.length > 0 && (
        <span
          className="flex items-center gap-1"
          style={{ color: 'var(--warn)' }}
          title={alerts.join('\n')}
        >
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: 'var(--warn)' }} />
          {alerts[0]}
          {alerts.length > 1 && <span className="num">+{alerts.length - 1}</span>}
        </span>
      )}

      <span className="ml-auto hidden sm:inline">
        双击图表区切换高度档 · ? 查看快捷键
      </span>
    </footer>
  );
}